import React, { useMemo, useState } from "react";
import * as FaIcons from "react-icons/fa";
import { NavLink, useParams, useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import ListaCursos from "./ListaCursos";
import { useMutation, useQueryClient } from "react-query";
import { deleteCurso } from "../../controllers/rutas/rutas";
import HeaderSearchTable from "../../components/Custom/HeaderSearchTable";
import CustomModal from "../../components/Modal/CustomModal";
import LoaderSmall from "../../components/Loaders/LoaderSmall";
import { delete_curso } from "../../controllers/historias/historias";

const HistoriasCursos = ({ id_historia, cursos }) => {
	const navigate = useNavigate();
	const queryClient = useQueryClient();
	const {
		mutate,
		error: errorCreate,
		isLoading: isLoadingCreate,
	} = useMutation(delete_curso, {
		onSuccess: () => {
			queryClient.refetchQueries(["getHistoria"])
		},
	});

	const [show, setShow] = useState(false);

	const [filterText, setFilterText] = useState("");
	const [resetPagination, setResetPagination] = useState(false);
	const [filteredItems, setFilteredItems] = useState([]);
	const handleSendToEdit = (slugCurso) => {
		navigate(`/editar-curso/${slugCurso}`);
	};

	/* Search Component */
	const searchComponentMemo = useMemo(() => {
		return (
			<HeaderSearchTable
				filterText={filterText}
				setFilterText={setFilterText}
				arrayData={cursos}
				setArrayFiltered={setFilteredItems}
				setResetPagination={setResetPagination}
				columnsToFilter={["nombre_curso"]}
				placeholder="Buscar por nombre del curso"
			/>
		);
	}, [filterText, resetPagination]);

	/* Config Table */
	const columns = useMemo(
		() => [
			{
				name: "#",
				cell: (row) => row.id_curso,
				wrap: true,
			},
			{
				name: "Nombre Curso",
				selector: (row) => (
					<div style={{ textAlign: "left", width: "100%" }}>
						{" "}
						{row.nombre_curso}{" "}
					</div>
				),
				sortable: true,
			},
			{
				name: "Acciones",
				cell: (row) => (
					<div className="d-flex">
						<span
							className="btn btn-danger btn-sm"
							title="Deshabilitar"
							onClick={() =>
								mutate({
									id_historia: id_historia,
									id_curso: row.id_curso,
								})
							}
						>
							<FaIcons.FaTrash />
						</span>
					</div>
				),
			},
		],
		[]
	);

	return (
		<>
			<CustomModal
				title={"Agregar curso"}
				show={show}
				handleShow={setShow}
			>
				<ListaCursos id_historia={id_historia} handleShow={setShow} />
			</CustomModal>
			
			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-start my-3">
						{" "}
						<span
							className="btn ge-btn-primary txt-white"
							onClick={() => setShow(!show)}
						>
							Agregar curso
						</span>{" "}
					</div>
					<DataTable
						className="custom-datatable"
						columns={columns}
						data={filteredItems.length > 0 ? filteredItems : cursos}
						subHeader
						subHeaderComponent={searchComponentMemo}
						pagination
						responsive
						fixedHeader
						fixedHeaderScrollHeight="300px"
						progressComponent={<LoaderSmall />}
					/>
				</div>
			</div>
		</>
	);
};

export default HistoriasCursos;
